import * as i0 from "@angular/core";
var INDRAStorageService = /** @class */ (function () {
    function INDRAStorageService() {
        this.currentSession = null;
    }
    INDRAStorageService.prototype.getCurrentSession = function () {
        return this.currentSession;
    };
    // getCurrentUser(): INDRAUserData {
    // 	const session: INDRASession = this.getCurrentSession();
    // 	return session && session.user ? session.user : null;
    // }
    INDRAStorageService.prototype.isAuthenticated = function () {
        return this.getCurrentToken() != null ? true : false;
    };
    INDRAStorageService.prototype.getCurrentToken = function () {
        var session = this.getCurrentSession();
        return session && session.sessionId ? session.sessionId : null;
    };
    INDRAStorageService.prototype.set = function (key, value, local) {
        try {
            if (local) {
                localStorage.setItem(key, JSON.stringify(value));
            }
            else {
                sessionStorage.setItem(key, JSON.stringify(value));
            }
        }
        catch (e) {
            if (local) {
                localStorage.removeItem(key);
                localStorage.setItem(key, JSON.stringify(value));
            }
            else {
                sessionStorage.removeItem(key);
                sessionStorage.setItem(key, JSON.stringify(value));
            }
        }
    };
    INDRAStorageService.prototype.get = function (key, local) {
        try {
            return local ? JSON.parse(localStorage.getItem(key)) : JSON.parse(sessionStorage.getItem(key));
        }
        catch (error) {
            return local ? localStorage.getItem(key) : sessionStorage.getItem(key);
        }
    };
    INDRAStorageService.prototype.remove = function (key, local) {
        if (local) {
            localStorage.removeItem(key);
        }
        else {
            sessionStorage.removeItem(key);
        }
    };
    INDRAStorageService.prototype.removeAll = function (local) {
        if (local) {
            localStorage.clear();
        }
        else {
            sessionStorage.clear();
        }
    };
    INDRAStorageService.ngInjectableDef = i0.defineInjectable({ factory: function INDRAStorageService_Factory() { return new INDRAStorageService(); }, token: INDRAStorageService, providedIn: "root" });
    return INDRAStorageService;
}());
export { INDRAStorageService };
